import { inject, Injectable } from '@angular/core';
import { PaceState, selectNotificationLoaded } from '@evorait/pace-core';
import { Store } from '@ngrx/store';
import { getIsEmptyPaceFormsState, handOverUnsubmittedForms } from '@evorait/pace-forms';
import { Observable, of, switchMap } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
// this service needs to reside here as it has dependencies on pace forms.
// Moving this service to pace-core
// would mean that pace-core has dependencies on the pace-forms lib
export class AutomaticFormsHandoverService {
    private readonly store = inject(Store<PaceState>);

    public handOverFormsOnCheckout(): Observable<boolean> {
        // The legacy notification service never dispatches into the NgRx notification slice, so
        // selectNotificationLoaded would stay `false` forever and this would never emit.
        const notificationLoaded$ = environment.enableNgRx
            ? this.store.select(selectNotificationLoaded).pipe(filter(Boolean), take(1))
            : of(true);

        return notificationLoaded$.pipe(
            switchMap(() => this.store.select(getIsEmptyPaceFormsState)),
            tap((isPaceFormStateEmpty) => {
                if (!isPaceFormStateEmpty) {
                    this.store.dispatch(handOverUnsubmittedForms());
                }
            }),
            filter((isPaceFormStateEmpty) => isPaceFormStateEmpty),
        );
    }
}
